import React from 'react';
import './Btn.css'

const Btn = (props) => {
    return ( 
        <button className={props.BtnStyle}>
            {props.BtnText}
        </button>
     );
}
 
export default Btn;